/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MatchResponse } from './MatchResponse';
import {
    MatchResponseFromJSON,
    MatchResponseFromJSONTyped,
    MatchResponseToJSON,
    MatchResponseToJSONTyped,
} from './MatchResponse';

/**
 * 
 * @export
 * @interface GetTournamentMatchesResponse
 */
export interface GetTournamentMatchesResponse {
    /**
     * 
     * @type {Array<MatchResponse>}
     * @memberof GetTournamentMatchesResponse
     */
    matches: Array<MatchResponse>;
    /**
     * 
     * @type {number}
     * @memberof GetTournamentMatchesResponse
     */
    total: number;
    /**
     * 
     * @type {number}
     * @memberof GetTournamentMatchesResponse
     */
    limit: number;
    /**
     * 
     * @type {number}
     * @memberof GetTournamentMatchesResponse
     */
    skip: number;
}

/**
 * Check if a given object implements the GetTournamentMatchesResponse interface.
 */
export function instanceOfGetTournamentMatchesResponse(value: object): value is GetTournamentMatchesResponse {
    if (!('matches' in value) || value['matches'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('limit' in value) || value['limit'] === undefined) return false;
    if (!('skip' in value) || value['skip'] === undefined) return false;
    return true;
}

export function GetTournamentMatchesResponseFromJSON(json: any): GetTournamentMatchesResponse {
    return GetTournamentMatchesResponseFromJSONTyped(json, false);
}

export function GetTournamentMatchesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetTournamentMatchesResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'matches': ((json['matches'] as Array<any>).map(MatchResponseFromJSON)),
        'total': json['total'],
        'limit': json['limit'],
        'skip': json['skip'],
    };
}

export function GetTournamentMatchesResponseToJSON(json: any): GetTournamentMatchesResponse {
    return GetTournamentMatchesResponseToJSONTyped(json, false);
}

export function GetTournamentMatchesResponseToJSONTyped(value?: GetTournamentMatchesResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'matches': ((value['matches'] as Array<any>).map(MatchResponseToJSON)),
        'total': value['total'],
        'limit': value['limit'],
        'skip': value['skip'],
    };
}

